<template>
  <div class="container text-center" style="max-width: 600px">
    <div class="text-right pt-3">
      <router-link to="/calendario" class="btn text-decoration-none font-weight-bold text-secondary" href="#">Pular</router-link>
    </div>
    <div class="d-flex justify-content-center align-items-center" style="height: 80vh" @click="proximo()">
      <div>
        <div v-if="step === 1">
          <div class="text-center">
            <!--<img src="../assets/icones/splash-ouvidoria.png" style="width: 200px">-->
          </div>
          <h4 class="font-weight-bold mb-3">Calendário</h4>
          <p>
            Acesse um calendário completo com todas as datas e horários das reuniões e serviços divinos da sua regional. Visualize facilmente os detalhes de cada evento com apenas um toque.
          </p>
        </div>
        <div v-else-if="step === 2">
          <div class="text-center">
            <!--<img src="../assets/icones/splash-servicos.png" style="width: 200px">-->
          </div>
          <h4 class="font-weight-bold mb-3">Listas de Batismo</h4>
          Acesse digitalmente a Lista de Batismo da sua regional.
        </div>
        <div class="mt-5">
          <button class="btn btn-primary">Próximo</button>
        </div>
      </div>
    </div>
    <div class="fixed-bottom py-4">
      <a href="#">
        <i class="fa-solid fa-circle mr-2 text-light" :class="{'text-primary': step === 1}"></i>
      </a>
      <a href="#">
        <i class="fa-solid fa-circle mr-2 text-white" :class="{'text-primary': step === 2}"></i>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
        step: 1
      }
    },

    methods: {
      proximo() {
        if (this.step < 2) {
          this.step++;
        } else {
          this.$router.push('/calendario')
        }
      }
    }
  }
</script>
<style scoped>
</style>
